import { render } from "./overviewSettimana.vue?vue&type=template&id=5abb5f05&ts=true"
import script from "./overviewSettimana.vue?vue&type=script&lang=ts"
export * from "./overviewSettimana.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__